export default __webpack_public_path__ + "93029f884b7d918155c3e47ea44f6547.svg";